import { render, staticRenderFns } from "./CabecalhoAtaView.vue?vue&type=template&id=90c6905c&scoped=true"
import script from "./CabecalhoAtaView.vue?vue&type=script&lang=js"
export * from "./CabecalhoAtaView.vue?vue&type=script&lang=js"
import style0 from "./CabecalhoAtaView.vue?vue&type=style&index=0&id=90c6905c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c6905c",
  null
  
)

export default component.exports